"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _SESPlugin = /*#__PURE__*/ _interop_require_default(require("./SESPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _SESPlugin.default,
    id: 'ses',
    title: 'SES',
    version: '0.0.4',
    logo: 'plugins/aws.png',
    icon: 'NcAmazonAws',
    description: 'Amazon Simple Email Service (SES) is a cost-effective, flexible, and scalable email service that enables developers to send mail from within any application.',
    price: 'Free',
    tags: 'Email',
    category: 'Email',
    inputs: {
        title: 'Configure Amazon Simple Email Service (SES)',
        items: [
            {
                key: 'from',
                label: 'From',
                placeholder: 'From',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'region',
                label: 'Region',
                placeholder: 'Region',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_key',
                label: 'Access Key',
                placeholder: 'Access Key',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_secret',
                label: 'Access Secret',
                placeholder: 'Access Secret',
                type: _nocodbsdk.XcType.Password,
                required: true
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully configured! Email notifications are now set up using Amazon SES.',
        msgOnUninstall: ''
    }
};
const _default = config;
